export default __webpack_public_path__ + "static/media/gallery-wip-emitter_11.f2bd5dab.jpg";